var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { id: "copy-application-modal" },
    on: { hidden: _vm.closingModal },
    scopedSlots: _vm._u([
      {
        key: "header-custom",
        fn: function () {
          return [
            _c("div", { staticClass: "d-flex flex-wrap" }, [
              _c("div", { staticClass: "vertical-center" }, [
                _c("h5", { staticClass: "modal-title bold" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("application.listing.copyApplication")) +
                      "\n        "
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "mb-3" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("application.messages.copyApplicationMessage")
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _vm.propertyAddress
              ? _c("checkbox-section", {
                  staticClass: "my-3",
                  attrs: {
                    label: _vm.$t("application.messages.checkBoxOne", {
                      propertyAddress: _vm.propertyAddress,
                    }),
                    checked: _vm.copyAsCurrentAddress,
                  },
                  on: {
                    change: function (value) {
                      return (_vm.copyAsCurrentAddress = value)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.propertyAddress
              ? _c("checkbox-section", {
                  staticClass: "my-3",
                  attrs: {
                    label: _vm.$t("application.messages.checkBoxTwo", {
                      propertyAddress: _vm.propertyAddress,
                    }),
                    checked: _vm.copyAsPropertyOwned,
                  },
                  on: {
                    change: function (value) {
                      return (_vm.copyAsPropertyOwned = value)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.currentAddressLength > 1
              ? _c("checkbox-section", {
                  staticClass: "my-3",
                  attrs: {
                    label: _vm.$t("application.messages.checkBoxThree"),
                    checked: _vm.copyAsPreviousAddress,
                  },
                  on: {
                    change: function (value) {
                      return (_vm.copyAsPreviousAddress = value)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.documentCount != 0
              ? _c("checkbox-section", {
                  staticClass: "my-3",
                  attrs: {
                    label: _vm.$t("application.messages.checkBoxFour"),
                    checked: _vm.copyDocuments,
                  },
                  on: {
                    change: function (value) {
                      return (_vm.copyDocuments = value)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  id: "submit-copying-form",
                  type: "button",
                  "class-name": "btn btn-primary",
                },
                on: { click: _vm.submit },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("application.listing.copyApplication")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }